import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import Inbox from '../containers/Inbox';
import Chat from '../containers/Chat';
import ErrorBoundary from '../containers/ErrorBoundary/index';
import Content from '../containers/Inbox/Compose/Content';
function Router() {
    var errorBoundaryComponent = React.createElement(ErrorBoundary, null);
    return (React.createElement(BrowserRouter, null,
        React.createElement(Sentry.ErrorBoundary, { fallback: errorBoundaryComponent },
            React.createElement(Routes, null,
                React.createElement(Route, { path: "/meldinger", element: React.createElement(Inbox, null) },
                    React.createElement(Route, { path: "ny", element: React.createElement(Content, null) })),
                React.createElement(Route, { path: "/meldinger/:id", element: React.createElement(Chat, null) })))));
}
export default Router;
